import request from '@/utils/request'

export const otherApi = {
    // 获取banner图
    getBanner: (params) => request({
        url: '/officialWebsite/bannerList',
        method: 'get',
        params
    }),
    getCompanyInfo: () => request({
        url: '/officialWebsite/company/info',
        method: 'get',
        params: {
            pageSize: 1,
        }
    }),
    getCompanyHistory: () => request({
        url: '/officialWebsite/company/history',
        method: 'get',
        params: {
            pageSize: 1000,
        }
    })
}